import { useEffect } from 'react';

const SELECTOR = 'section[id] h2, section[id] .reveal, section[id] [data-testid^="service-card-"], section[id] [data-testid^="review-card-"], section[id] [data-testid^="gallery-"], section[id] form';

export const useScrollReveal = (deps = []) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('reveal-visible');
          observer.unobserve(e.target);
        }
      }),
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.classList.contains('reveal-visible')) return;
      el.classList.add('reveal');
      observer.observe(el);
    });
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
